import styled, {css} from 'styled-components';
import {getColors} from '../../utils/styling';
import theme from '../../utils/styling/defaultTheme';

const NavDropdown = styled.div`
  position: relative;
  
  .nav-dropdown-trigger {
    cursor: pointer;
    border: none;
    outline: none;
    height: 24px;
    color: ${({theme, variant}) => variant === 'dark' ? theme.colors.gray300 : theme.colors.gray600};
    background: none;
    
    span {
      margin-right: 6px;
      font-size: 16px;
    }
    
    .caret-icon {
      margin-bottom: 2px;
      fill: ${({theme, variant}) => variant === 'dark' ? theme.colors.gray300 : theme.colors.gray600};
      transition: transform 200ms;
    }
  }
  
  &:hover {
    .nav-dropdown-trigger {
     color: ${({theme, variant}) => variant === 'dark' ? theme.colors.gray100 : theme.colors.gray900};
    }
    
    .caret-icon {
      transform: rotate(180deg);
      fill: ${({theme, variant}) => variant === 'dark' ? theme.colors.gray100 : theme.colors.gray900};
    }
  
    .nav-dropdown-items-wrapper {
      display: block;
      opacity: 1;
      animation: opacity 300ms ease-in-out normal;
      -moz-animation: opacity 300ms ease-in-out normal;
      -ms-animation: opacity 300ms ease-in-out normal;
      -o-animation: opacity 300ms ease-in-out normal;
      -webkit-animation: opacity 300ms ease-in-out normal;    
    }
    
  }
  
  .nav-dropdown-items-wrapper {
    position: absolute;
    left: -24px;
    z-index: 100;
    display: none;
    
     &:before {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      top: 10px;
      left: 48px;
      transform: translateX(-50%);
      border-width: 0 5px 7px 5px;
      border-color: transparent transparent #ffffff transparent;
    }
  
  }
  
 
    
  .nav-dropdown-items {
    border-radius: 4px;
    margin-top: 16px;
    padding: 24px 0 24px 0;
    width: 320px;
    background-color: ${getColors(theme).white};
    box-shadow: 0 0 24px rgba(74,85,104,0.1);
    
    a {
      margin: 0;
      width: 100%;
      font-size: 16px;
      
      &:hover {
        ${({theme}) => css`background-color: ${getColors(theme).gray100}`};
      }
    }
  }
  
  @keyframes opacity { 
    from { opacity:0; } 
    to { opacity: 1; } 
  }
  @-moz-keyframes opacity { 
      from { opacity: 0; } 
      to { opacity: 1; } 
  }
  @-ms-keyframes opacity { 
      from {opacity:0; } 
      to { opacity: 1; } 
  }
  @-o-keyframes opacity { 
      from {opacity:0; } 
      to { opacity: 1; } 
  }
  @-webkit-keyframes opacity { 
      from { opacity:0; } 
      to { opacity: 1; } 
  }
`;

const NavDropdownItem = styled.div`
  padding: 8px 24px 8px 24px;
  width: 100%;
  
  .title {
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 18px;
    ${({color}) => color &&
    css`${({theme}) => css`color: ${getColors(theme)[color]}`};`}
  }
  
  .description {
    font-size: 16px;
    color: ${({theme}) => theme.colors.gray600};
    
    em {
      font-style: normal;
      font-weight: bold;
    }
  }
`;

export {NavDropdown, NavDropdownItem};
